import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HeaderHelperService } from '../header-helper.service';

@Injectable({
  providedIn: 'root',
})
export class PatientsService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  getConclusionOptions(code: string): Observable<any> {
    let url = `${environment.apiLocations.patient}/ConclusionOption/ConclusionOptionsByApplicationCode/${code}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  getConclusionOptionDetail(id: string): Observable<any> {
    let url = `${environment.apiLocations.patient}/ConclusionOptionContent/${id}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  createConclusionOption(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiLocations.patient}/ConclusionOption`,
      data,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  deleteConclusionOptionContent(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiLocations.patient}/ConclusionOptionContent/${id}`,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  editConclusionOptionContent(id: string, data: any): Observable<any[]> {
    return this.http.put<any[]>(
      `${environment.apiLocations.patient}/ConclusionOptionContent/${id}`,
      data,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  addConclusionOption(id: string, data: any): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiLocations.patient}/ConclusionOptionContent/${id}`,
      data,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }
}
